<template>
    <div class="deposit-amount-wrapper" v-if="!this.$helper.isMobile()">
        <div class="deposit-desktop d-flex">
            <div class="deposit-desktop__leftpage">
                <div class="deposit-left-side-container">
                    <div class="wallet-no-bx">
                        <div class="deposit-head">
                            <h3>Deposit</h3>
                        </div>
                    </div>
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="bank1-tab" role="tabpanel"
                            aria-labelledby="pills-home-tab">
                            <BankAccountDetails :bankAccounts="paymentDetailsList" :s3Url="s3Url" @change-account="changeAccount" @copyText="copyText" v-if="currentPaymentId == 1" />
                            <UpiAccountDetails :upiAccounts="paymentDetailsList" :s3Url="QRs3Url" @change-account="changeAccount" @copyText="copyText" v-else />
                        </div>
                        <div class="deposit top-cards_wrapper p-0 m-0" v-if="!accountId && paymentDetailsList && !paymentDetailsList.length">
                            <div class="page-subtitle notes ps-0">
                                <p>No Deposit Options Available. Contact admin!!</p>
                            </div>
                        </div>
                    </div>
                    <div class="depositNotes">
                        <div class="depositNotes-title">Notes</div>
                        <div class="depositNotes-content"><img src="@/assets/images/dashedBorder.webp" alt="dashedBorder"
                                class="depositNotes-content-img">
                            <div class="depositNotes-content-text">Make Payment with Payment methods</div>
                            <div class="depositNotes-content-text">Copy and Enter the 12 digit UTR Number</div>
                            <div class="screentshot-dposit-banner">
                                <div id="deposit-screenshot-slider-mobile" class="owl-carousel owl-theme">
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide1.webp" alt="depositSlide1"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide2.webp" alt="depositSlide2"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide3.webp" alt="depositSlide3"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide4.webp" alt="depositSlide4"></figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="deposit-desktop__rightpage">
                <div class="deposit-right-side-container deposit-amount-container">
                    <div class="payment-option-sec" v-if="parentPaymentsList && parentPaymentsList.length">
                        <ul class="payment-bg-sec nav nav-pills" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation" v-for="(payment, index) in parentPaymentsList"
                                :key="index" @click="changePaymentMethod(payment, index)">
                                <button class="nav-link" :class="{ active: activeTab === index }" id="pills-home-tab"
                                    data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                                    aria-controls="pills-home" aria-selected="true">
                                    <div class="item-123">
                                        <div class="check">
                                            <div class="deposit-option-list">
                                                <div class="payments__row-item-radio">
                                                    <div class="unSelectedRadio"></div>
                                                </div>
                                                <div class="payment-option-logo">
                                                    <img class="payments__row-item-logo-img"
                                                        :src="payment.id == 1 ? bankS3url + payment?.bank_icon : s3Url + payment?.icon"
                                                        alt="payment-image" loading="lazy" />
                                                </div>
                                                <span class="payments__row-item-logo-title">{{ payment.name ??
                                                    payment.bank_name}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="deposit top-cards_wrapper p-0 m-0" v-else-if="parentPaymentsList">
                        <div class="page-subtitle notes ps-0">
                            <p>No Options Available. Enter different amount.</p>
                        </div>
                    </div>
                    <div class="amount-sec">
                        <div class="deposit total-amount">
                            <label class="form-label">Amount*</label>
                            <div class="deposit-amountInput">
                                <input type="number" v-model="depositAmount" :disabled="parentPaymentsList && parentPaymentsList.length" class="enter-amount-box">
                                <span class="deposit-amountInput-currency" v-if="parentPaymentsList && parentPaymentsList.length" @click="parentPaymentsList = null">Edit</span>
                                <span class="text-danger mt-2 error-messages-text" v-if="v$.depositAmount.$error">Please Enter Amount</span>
                            </div>
                            <span class="amount-limit">Min Amount: {{ walletLimits ? walletLimits.deposit_limit : 100 }}</span>
                            <template v-if="!(parentPaymentsList && parentPaymentsList.length)">
                                <div class="grid-container grid-container-three" v-if="chips">
                                    <button @click="setStakeValue(chips.chip_val_1)" class="grid-item">+{{ chips.chip_val_1
                                        }}</button>
                                    <button @click="setStakeValue(chips.chip_val_2)" class="grid-item">+{{ chips.chip_val_2
                                        }}</button>
                                    <button @click="setStakeValue(chips.chip_val_3)" class="grid-item">+{{ chips.chip_val_3
                                        }}</button>
                                    <button @click="setStakeValue(chips.chip_val_4)" class="grid-item">+{{ chips.chip_val_4
                                        }}</button>
                                    <button @click="setStakeValue(chips.chip_val_5)" class="grid-item">+{{ chips.chip_val_7
                                        }}</button>
                                    <button @click="setStakeValue(chips.chip_val_7)" class="grid-item">+{{ chips.chip_val_7
                                        }}</button>
                                </div>
                                <div class="proceed-btn">
                                    <button type="button" @click="callForDepositMethods">Submit</button>
                                </div>
                            </template>
                        </div>
                        <template v-if="accountId">
                            <div class="deposit total-amount" ref="utrSection">
                                <div class="deposit__title">Upload your photo below</div>
                                <div class="text-center" v-if="previewImage">
                                    <div @click="removeImage()">
                                        <i class="fa fa-times-circle"></i>
                                    </div>
                                    <img :src="previewImage" width="200px" />
                                </div>
                                <label class="sc-beySbM jncdCN imageUploader " for="file">
                                    <input accept="image/png, image/jpeg, image/jpg, image/gif"
                                        @change="onUploadImage($event)" type="file" name="file">
                                    <i><img src="@/assets/images/upload-photo-img.webp" alt="upload-photo-img"> </i>
                                    <div class="sc-dmyDGi PLPSy"><span class="sc-hLQRIN iDaYzZ"><span>Upload</span>&nbsp;or
                                            drop a file right
                                            here</span></div>
                                </label>
                            </div>
                            <div class="deposit total-amount total-amount">
                                <!-- <div class="deposit__title">Enter UTR Number</div> -->
                                <p class="mb-1">Kindly enter {{ currentPaymentId == 18 ? 'Transaction Hash' : 'UTR Number' }} manually for fast deposit.</p>
                                <input type="text" v-model="manual_utr" @input="sanitizeInput" :placeholder="currentPaymentId == 18 ? 'Transaction Hash' : '10 or 12 Digit UTR Number'" :maxlength="currentPaymentId == 18 ? 70 : 20"
                                    class="enter-amount-box">
                            </div>
                            <div class="deposit">
                                <div class="rules-button">
                                    <div class="rulesAccept">
                                        <div class="form-check"><input type="checkbox" v-model="termCondition" value="true" id="consolidate" class="form-check-input"> 
                                            <label class="form-check-label">
                                                <span class="rulesAccept__text">
                                                    I have read and agree with&nbsp;
                                                    <a href="#payment-policy" data-bs-toggle="modal"
                                                        class="rulesAccept__text-underline">
                                                        the terms of payment and withdrawal policy.
                                                    </a>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="proceed-btn" @click="submitDepositAmount()" ref="sbtBtn">
                                        <button type="button">
                                            Proceed
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="deposit-and-withdrawal-sec  mobile-amount-wrapper" v-if="this.$helper.isMobile()">
        <div class="container">
            <div class="choose-odds-sec" v-if="parentPaymentsList">
                <div class="deposit top-cards_wrapper">
                    <template v-if="parentPaymentsList && parentPaymentsList.length">
                        <div class="deposit__title">Payment Options</div>
                        <div class="payment-option-sec">
                            <ul class="payment-bg-sec nav nav-pills" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation" v-for="(payment, index) in parentPaymentsList"
                                    :key="index" @click="changePaymentMethod(payment, index)">
                                    <button class="nav-link" :class="{ active: activeTab === index }" id="pills-home-tab"
                                        data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                                        aria-controls="pills-home" aria-selected="true">
                                        <div class="item-123">
                                            <div class="check">
                                                <div class="deposit-option-list">
                                                    <div class="payments__row-item-radio">
                                                        <div class="unSelectedRadio"></div>
                                                    </div>
                                                    <div class="payment-option-logo">
                                                        <img class="payments__row-item-logo-img"
                                                            :src="payment.id == 1 ? bankS3url + payment?.bank_icon : s3Url + payment?.icon"
                                                            alt="payment-image" loading="lazy" />
                                                    </div>
                                                    <span class="payments__row-item-logo-title">{{ payment.name ??
                                                        payment.bank_name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <div class="deposit top-cards_wrapper p-0 m-0" v-else-if="parentPaymentsList">
                        <div class="page-subtitle notes ps-0">
                            <p>No Options Available</p>
                        </div>
                    </div>
                </div>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <BankAccountDetails :bankAccounts="paymentDetailsList" :s3Url="s3Url" @copyText="copyText" @change-account="changeAccount" v-if="currentPaymentId == 1" />
                        <UpiAccountDetails :upiAccounts="paymentDetailsList" :s3Url="QRs3Url" @copyText="copyText" @change-account="changeAccount" v-else />
                        <template v-if="accountId">
                            <div class="deposit total-amount mt-2" ref="utrSection">
                                <div class="deposit__title">Upload your photo below</div>
                                <div class="text-center" v-if="previewImage">
                                    <div @click="removeImage()">
                                        <i class="fa fa-times-circle"></i>
                                    </div>
                                    <img :src="previewImage" width="200px" />
                                </div>
                                <label class="sc-beySbM jncdCN imageUploader " for="file" v-if="!previewImage">
                                    <input @change="onUploadImage($event)" accept="image/png, image/jpeg, image/jpg, image/gif" type="file" name="file" id="file" />
                                    <i>
                                        <img src="@/assets/images/upload-photo-img.webp" alt="upload-photo-img">
                                    </i>
                                    <div class="sc-dmyDGi PLPSy">
                                        <span class="sc-hLQRIN iDaYzZ">
                                            <span>Upload</span>&nbsp;or drop a file right here</span>
                                    </div>
                                </label>
                            </div>

                            <div class="deposit total-amount total-amount">
                                <p class="mb-1">Kindly enter {{ currentPaymentId == 18 ? 'Transaction Hash' : 'UTR Number' }} manually for fast deposit.</p>
                                <input type="text" :maxlength="currentPaymentId == 18 ? 70 : 20" v-model="manual_utr" @input="sanitizeInput" :placeholder="currentPaymentId == 18 ? 'Transaction Hash' : '10 or 12 Digit UTR Number'"
                                    class="enter-amount-box">
                            </div>
                        </template>
                        <div class="deposit top-cards_wrapper p-0 m-0" v-else-if="!accountId && paymentDetailsList && !paymentDetailsList.length">
                            <div class="page-subtitle notes ps-0">
                                <p>No Options Available. Contact admin!!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="deposit total-amount mt-3">
                <div class="d-flex justify-content-between">
                    <div class="deposit__title">Deposit Amount*</div>
                    <span class="amount-limit">Min Amount: {{ walletLimits ? walletLimits.deposit_limit : 100 }} </span>
                </div>
                <div class="deposit-amountInput">
                    <input type="number" v-model="depositAmount" placeholder="0" :disabled="parentPaymentsList && parentPaymentsList.length"
                        class="enter-amount-box">
                    <span class="deposit-amountInput-currency" v-if="parentPaymentsList && parentPaymentsList.length" @click="parentPaymentsList = null">Edit</span>
                    <span class="text-danger mt-2 error-messages-text" v-if="v$.depositAmount.$error">Please Enter
                        Amount</span>
                </div>
                <template v-if="!(parentPaymentsList && parentPaymentsList.length)">
                    <div class="grid-container" v-if="chips">
                        <button @click="setStakeValue(chips.chip_val_1)" class="grid-item">
                            +{{ chips.chip_val_1 }}
                        </button>
                        <button @click="setStakeValue(chips.chip_val_2)" class="grid-item">
                            +{{ chips.chip_val_2 }}
                        </button>
                        <button @click="setStakeValue(chips.chip_val_3)" class="grid-item">
                            +{{ chips.chip_val_3 }}
                        </button>
                        <button @click="setStakeValue(chips.chip_val_4)" class="grid-item">
                            +{{ chips.chip_val_4 }}
                        </button>
                        <button @click="setStakeValue(chips.chip_val_5)" class="grid-item">
                            +{{ chips.chip_val_5 }}
                        </button>
                        <button @click="setStakeValue(chips.chip_val_6)" class="grid-item">
                            +{{ chips.chip_val_6 }}
                        </button>
                    </div>
                    <div class="proceed-btn">
                        <button type="button" @click="callForDepositMethods">Submit</button>
                    </div>
                </template>
            </div>
            <div class="choose-odds-sec" v-if="parentPaymentsList">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <template v-if="accountId">
                            <div class="deposit rules-button">
                                <div class="rulesAccept">
                                    <div class="form-check">
                                        <input class="form-check-input" v-model="termCondition" type="checkbox" value=""
                                            id="consolidate">
                                        <label class="form-check-label">
                                            <span class="rulesAccept__text">I have read and agree with&nbsp;
                                                <a href="#payment-policy" data-bs-toggle="modal" class="rulesAccept__text-underline">the terms
                                                    of payment and
                                                    withdrawal policy.</a>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="proceed-btn" ref="sbtBtn">
                                    <button type="button" @click="submitDepositAmount()"> Proceed</button>
                                </div>
                                <div class="deposit top-cards_wrapper p-0 m-0">
                                    <div class="page-subtitle notes ps-1">
                                        <p>1. Deposit money only in the selected account to get the fastest credits and
                                            avoid
                                            possible
                                            delays.</p>
                                        <p>2. Deposits made 45 minutes after the account removal from the site are valid &amp; will
                                            be
                                            added
                                            to
                                            their wallets.</p>
                                        <p>3. We is not responsible for money deposited to Old, Inactive or Closed accounts.</p>
                                        <p>4. After deposit, add your UTR and amount to receive balance. </p>
                                        <p>5. NEFT receiving time varies from 40 minutes to 2 hours. </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <LanguageModal />
</template>
<script>
import { createWorker } from 'tesseract.js';
import { defineAsyncComponent } from 'vue';
import ocrCheck from '../services/ocrCheck';
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
export default {
    name: "WalletDeposit",
    inject: ['walletLimits'],
    extends: ocrCheck,
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        LanguageModal: defineAsyncComponent(() =>
            import('../components/LanguageModal.vue')
        ),
        UpiAccountDetails: defineAsyncComponent(() =>
            import('../components/UpiAccountDetails.vue')
        ),
        BankAccountDetails: defineAsyncComponent(() =>
            import('../components/BankAccountDetails.vue')
        ),
    },
    data() {
        return {
            depositAmount: null,
            userJourneyVideo: this.$store?.getters?.siteSettings?.user_journey,
            parentPaymentsList: null,
            s3Url: null,
            bankS3url: null,
            activeTab: null,
            currentPaymentId: null,
            bankId: null,
            paymentDetailsList: null,
            uploadedImage: null,
            manual_utr: null,
            tesseract_utr: null,
            previewImage: null,
            accountId: null,
            utr_msg: null,
            QRs3Url: null,
            termCondition: false
        }
    },
    validations: {
        depositAmount: { required }
    },
    computed: {
        chips() {
            return this.$store.getters.chips;
        },
    },
    methods: {
        scrollToref(element) {
            setTimeout(() => {
                element.scrollIntoView({ 
                    behavior: "smooth", 
                    inline: "nearest",
                    block: "end"
                });
            }, 200) 
        },
        getParentPaymentsMethods() {
            let data = {
                depositAmount: this.depositAmount,
                template_name: this.$siteSettings.data.template_name || 'lotus'
            }
            this.$apiCall('post', 'GET_PARENT_PAYMENT_METHODS', data).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response?.data?.debug[0]);
                    }
                    else {
                        this.parentPaymentsList = response?.data?.paymentMethods
                        this.s3Url = response?.data?.s3Url;
                        this.bankS3url = response?.data?.bankS3url;
                        this.changePaymentMethod(this.parentPaymentsList[0], 0)
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        getDepositAccounts(paymentType) {
            this.$apiCall('get', 'GET_PARENT_PAYMENT_METHOD_DETAILS', null, 'user', {
                id: paymentType.id,
                bankId: paymentType.bank_id,
                amount: this.depositAmount,
            }).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response?.data?.debug[0]);
                    }
                    else {
                        this.paymentDetailsList = response?.data?.paymentMethods
                        this.QRs3Url = response?.data?.s3Url
                        this.accountId = this.paymentDetailsList[0].id;
                        this.bankId = this.paymentDetailsList[0].bank_id;
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        changePaymentMethod(payment, index) {
            this.activeTab = index;
            this.currentPaymentId = payment?.id;
            this.bankId = payment?.bank_id;
            this.removeImage();
            this.manual_utr = null;
            this.tesseract_utr = null;
            this.getDepositAccounts(payment)
        },

        submitDepositAmount() {
            if (!this.accountId || this.accountId == null) {
                this.$toasted.error('Please select account', { icon: 'error' });
                return false;
            }
            if (!this.uploadedImage || this.uploadedImage == null) {
                this.$errorToast('Please upload image');
                return
            }
            if (!this.depositAmount || this.depositAmount == null) {
                this.$errorToast('Please Enter Deposit Amount');
                return
            }
            if (!this.manual_utr || this.manual_utr == null) {
                this.$errorToast(this.currentPaymentId == 18 ? 'Please enter transaction hash' : 'Please Enter UTR');
                return
            }
            if (!this.termCondition || this.termCondition == null) {
                this.termCondition = true;
            }
            const walletDepositData = new FormData();
            walletDepositData.append("bank_amount", this.depositAmount);
            walletDepositData.append("bank_account_id", this.accountId);
            walletDepositData.append('image', this.uploadedImage);
            walletDepositData.append('manual_utr', this.manual_utr);
            walletDepositData.append('tesseract_utr', this.tesseract_utr);

            this.$apiCall('post', 'SUBMIT_DEPOSIT_AMOUNT', walletDepositData).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response?.data?.error);
                    }
                    else {
                        this.$successToast(response?.data?.data)
                        this.$router.push({name: 'Home'});
                        this.removeImage()
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },

        async onUploadImage(event) {
            try {
                const file = event.target.files[0];
                const maxFileSize = 4 * 1024 * 1024;
                if (file.size > maxFileSize) {
                    this.$errorToast(`File ${file.name} should be size limit of 4 MB.`)
                    return
                }
                this.previewImage = URL.createObjectURL(file)
                this.uploadedImage = file
                this.scrollToref(this.$refs.utrSection);
                if(this.currentPaymentId == 18) return;
                this.$store.dispatch('setGlobalLoader', true);
                this.manual_utr = await this.recognize(this.previewImage);
                this.tesseract_utr = this.manual_utr;
                if(this.manual_utr) {
                    this.utrMsg = {
                        langKey: 'found-img-utr-found',
                        msg:"We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit."
                    };
                    this.utrLoader = false;
                    this.scrollToref(this.$refs.sbtBtn);
                    this.$store.dispatch('setGlobalLoader', false);
                    return;
                };

                if (this.depositAmount > 0) {
                    var form = new FormData();
                    form.append('image', this.uploadedImage);
                    this.$apiCall('post', 'GET_AUTO_UTR', form).then(response => {
                        if (response?.status == 200) {
                            if (response?.data?.error) {
                                this.$errorToast(response?.data?.error);
                            } else {
                                if (response.data.utr != null) {
                                    this.manual_utr = response.data.utr;
                                    this.utr_msg = "We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit.";
                                } else {
                                    this.manual_utr = '';
                                    this.utr_msg = "We didn't find any UTR Number from uploaded screenshot by you, Kindly enter UTR Number manually for fast deposit.";
                                }
                            }
                            this.$store.dispatch('setGlobalLoader', false);
                        }
                    }).catch(error => {
                        this.$store.dispatch('setGlobalLoader', false);
                        if (error) {
                            this.$errorToast(error[0]);
                        }
                    });
                }
            } catch (e) {
                this.$store.dispatch('setGlobalLoader', false);
                this.$errorToast(e + 'refresh the page and try again!!');
            }
        },
        async recognize(prevImgs) {
            try {
                const img = prevImgs;
                const worker = await createWorker('eng');
                let { data: { text } } = await worker.recognize(img);
                await worker.terminate();
                return this.checkAll(text);
            } catch (e) {
                // this.$errorToast(e + 'refresh the page and try again!!');
                return null
            }
        },
        setStakeValue(stake) {
            this.depositAmount += parseFloat(stake);
        },

        changeAccount(data) {
            this.accountId = data.id

        },
        removeImage() {
            this.uploadedImage = null
            this.previewImage = null
        },
        copyText(content) {
            let dummy = document.createElement('input'),
                text = content;
            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            this.$successToast("Copy Content Successfully !!");
        },
        callForDepositMethods() {
            this.v$.$touch()
            if (this.v$.$error) {
                console.log(this.v$.$error)
                return
            } else {
                if (!this.depositAmount || this.depositAmount < this.walletLimits?.deposit_limit) {
                    this.parentPaymentsList = [];
                    this.$errorToast('Please enter amount greter than equal to ' + this.walletLimits?.deposit_limit);
                } else {
                    this.getParentPaymentsMethods()
                }
            }
        },
        sanitizeInput() {
            if(this.currentPaymentId != 18) {
                this.manual_utr = this.manual_utr.replace(/\D+/g, '');
            };
        }

    }
}
</script>